import SettingShop from './SettingShop.vue';

export default SettingShop;
